/**
 * Formulario simple para solicitar email de Apolearn cuando se accede a una actividad por URL
 */

import React, { useState } from 'react';
import './ActivityEmailForm.css';

interface ActivityEmailFormProps {
  onSubmit: (email: string) => Promise<void>;
  error?: string | null;
  loading?: boolean;
}

export function ActivityEmailForm({ onSubmit, error, loading = false }: ActivityEmailFormProps) {
  const [email, setEmail] = useState('');
  const [localError, setLocalError] = useState<string | null>(null);

  const validateEmail = (email: string): boolean => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLocalError(null);

    // Validar formato de email
    if (!email.trim()) {
      setLocalError('Por favor ingresa tu correo electrónico');
      return;
    }

    if (!validateEmail(email.trim())) {
      setLocalError('Por favor ingresa un correo electrónico válido');
      return;
    }

    try {
      await onSubmit(email.trim());
    } catch (err) {
      // El error se maneja en el componente padre
      setLocalError('Verifica que sea tu correo de apolearn');
    }
  };

  const displayError = error || localError;

  return (
    <div className="activity-email-form-overlay">
      <div className="activity-email-form-container">
        <div className="activity-email-form-header">
          <h2>Ingresa tu correo de Apolearn</h2>
          <p>Para acceder a esta actividad, necesitamos verificar tu identidad</p>
        </div>

        <form onSubmit={handleSubmit} className="activity-email-form">
          <div className="activity-email-form-field">
            <label htmlFor="email">Correo electrónico</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                setLocalError(null);
              }}
              placeholder="tu.correo@ejemplo.com"
              disabled={loading}
              autoFocus
              autoComplete="email"
            />
          </div>

          {displayError && (
            <div className="activity-email-form-error">
              {displayError}
            </div>
          )}

          <button
            type="submit"
            className="activity-email-form-submit"
            disabled={loading || !email.trim()}
          >
            {loading ? 'Verificando...' : 'Aceptar'}
          </button>
        </form>
      </div>
    </div>
  );
}
